'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('ballot-edit', {
      url: '/voting/edit/:voteId/ballot/edit/:id',
      template: '<ballots-edit></ballots-edit>',
      authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/ballot/ballot-edit/ballot-edit.routes.js